<div *ngIf="expenseReasonName!==''" class="mb-4 p-4rounded-lg">
      <h3 class="text-xl font-bold mb-2">Detalles del Pago</h3>
      <div class="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span class="font-bold">Motivo de gasto:</span> {{ expenseReasonName }}
        </div>
        <div>
          <span class="font-bold">Total:</span> {{ total }}
        </div>
      </div>
    </div>

    <div class="mx-auto flex w-full flex-wrap p-4" style="height: calc(100vh - 200px)">
            <div class="flex flex-col flex-1 min-h-0 overflow-auto">
                    <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
                        (matSortChange)="changeSort($event)">

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left text-sm">
                            </th>
                            <td mat-cell *matCellDef="let element" class=" text-left first-col text-sm leading-normal">
                                <mat-icon *ngIf="element.statusId == StatusEnum.INACTIVE" svgIcon="heroicons_solid:x-circle"
                                    matTooltip="Anulado" style="color:rgb(141, 19, 19); cursor: pointer;"></mat-icon>
                                <mat-icon *ngIf="element.statusId == StatusEnum.ACTIVE" svgIcon="heroicons_solid:check-circle"
                                    matTooltip="Activo" style="color:rgb(65, 106, 218); cursor: pointer;"></mat-icon>
                                <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_IN_PROGRESS" svgIcon="heroicons_solid:play-circle"
                                    matTooltip="En progreso"
                                    style="color:rgb(236, 199, 58); cursor: pointer;"></mat-icon>
                                <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_APPROVED" svgIcon="heroicons_solid:check-circle"
                                    matTooltip="Aprobado" style="color:rgb(9, 133, 50); cursor: pointer;"></mat-icon>
                                <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_REJECTED" svgIcon="heroicons_solid:x-circle"
                                    matTooltip="Rechazado" style="color:rgb(255, 0, 0); cursor: pointer;"></mat-icon>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="statusERP">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col text-sm">
                            </th>
                            <td mat-cell *matCellDef="let element" class=" text-left first-col text-sm leading-normal">
                                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_PENDING || !(element.statusERP)"
                                    svgIcon="heroicons_solid:clock" matTooltip="Pendiente envío a ERP"
                                    style="color:rgb(233, 124, 61); cursor: pointer;"></mat-icon>
                                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_SEND" svgIcon="heroicons_solid:document-arrow-up"
                                    matTooltip="Enviado a ERP" style="color:rgb(65, 106, 218); cursor: pointer;"></mat-icon>
                                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_RECEIVED"
                                    svgIcon="heroicons_solid:document-arrow-down" matTooltip="Recibido por ERP"
                                    style="color:rgb(236, 199, 58); cursor: pointer;"></mat-icon>
                                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_CREATED" svgIcon="heroicons_solid:document-check"
                                    matTooltip="Creado en ERP" style="color:rgb(9, 133, 50); cursor: pointer;"></mat-icon>
                                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_ERROR"
                                    svgIcon="heroicons_solid:exclamation-triangle" matTooltip="Error enviando a ERP"
                                    style="color:rgb(141, 19, 19); cursor: pointer;"></mat-icon>
                                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE"
                                    svgIcon="heroicons_solid:clock" matTooltip="Mod. pendiente de replicar"
                                    style="color:rgb(148, 46, 139); cursor: pointer;"></mat-icon>
                                <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_ERROR_ERP"
                                    svgIcon="heroicons_solid:exclamation-triangle" matTooltip="Error en ERP"
                                    style="color:rgb(255, 0, 0); cursor: pointer;"></mat-icon>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="routeUser">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-md">Ruta - Usuario
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-sm">
                                <div class="leading-tight">
                                    <app-user-route-display [routeData]="{
                        routeName: element?.subRoute?.name ?? '-',
                        externalKeys: { code: getCode(element.subRoute) ?? '-' }
                      }" [userData]="{name: element?.user?.user_login ?? '-', username: element?.user?.user_login?.username ?? element?.user?.user_login ?? '-' }"
                                        [responsibleData]="{name: element?.responsibleName ?? element?.responsibleBusinessPartner?.name ?? element?.responsible?.name ?? '-', externalKeys: { code: element?.responsibleCode ?? element?.responsibleBusinessPartner?.externalKeys?.code ?? element?.responsible?.externalKeys?.code ?? '-' }}"
                                        [displayMode]="'detailed'" [showRouteCode]="true" [showUser]="true"
                                        [showResponsible]="true">
                                    </app-user-route-display>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="serials">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-md">Nro. Doc.</th>
                            <td mat-cell *matCellDef="let element" class="text-xs break-words whitespace-normal max-w-[180px]">
                                {{element.serial}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="expenseReason">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-md">Motivo de gasto
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-xs break-words whitespace-normal max-w-[180px]">
                                {{element.reasonForExpense.name}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="typeDocument">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-md">Tipo de documento
                            </th>
                            <td mat-cell *matCellDef="let element" class="whitespace-nowrap text-xs">
                                <div>
                                    <b class="f-10">{{ element.type.code }}</b>
                                </div>
                                {{element.type.name}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="classDocument">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-md">Clase de documento
                            </th>
                            <td mat-cell *matCellDef="let element" class="whitespace-nowrap text-xs">
                                <div>
                                    <b class="f-10">{{ element.class.code }}</b>
                                </div>
                                {{element.class.name}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="amount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-md">
                                Monto</th>
                            <td mat-cell *matCellDef="let element" class="whitespace-nowrap text-xs">
                                <div class="whitespace-nowrap font-medium">
                                    {{element.amount | decimalFormat}}
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="creationDateTime">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-md">Creación</th>
                            <td mat-cell *matCellDef="let element" class="text-sm">
                                <div class="text-content">
                                    {{element?.creationDateTime | FormatDateHour: true }}
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="updatedDateTime">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-md">Actualización</th>
                            <td mat-cell *matCellDef="let element" class="text-sm">
                                <div class="text-content">
                                    {{element?.updatedDateTime | FormatDateHour: true }}
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="details">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-md">Ver más</th>
                            <td mat-cell *matCellDef="let element" class="whitespace-nowrap text-xs">

                                <div class="flex items-center space-x-1 px-6">

                                    <button *ngIf="element.observation" mat-icon-button color="primary"
                                        (click)="openNoteDetail(element)" matTooltip="Ver nota">
                                        <mat-icon svgIcon="heroicons_outline:chat-bubble-bottom-center-text"></mat-icon>
                                    </button>

                                    <button *ngIf="element?.images && element?.images?.length > 0" mat-icon-button
                                        color="primary" (click)="openGalleryModal(element)" matTooltip="Ver imágenes">
                                        <mat-icon svgIcon="heroicons_outline:photo"></mat-icon>
                                    </button>

                                    <span
                                        *ngIf="!element.observation && (!element.images || element.images.length === 0)">-</span>

                                </div>
                            </td>
                        </ng-container>

                        <!-- Header Row -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10 bg-white">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="order-row h-16"></tr>
                    </table>
                <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-lg">Lo
                    sentimos,
                    no hay registros para mostrar.
                </div>

                <div class="flex-shrink-0 mt-4">
                    <mat-paginator class="z-10" [pageSizeOptions]="[5,10,20,50]" showFirstLastButtons
                        [length]="totalItems" [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
                </div>
            </div>
    </div>

    <ng-template #commentsModal>
        <div class="flex items-center justify-between">
            <h2 mat-dialog-title class="text-lg font-bold">Comentarios</h2>
            <div class="flex items-center mr-4">
                <mat-icon svgIcon="heroicons_outline:x-circle" matTooltip="Cerrar" class="close-button" mat-dialog-close
                    style="cursor: pointer;"></mat-icon>
            </div>
        </div>
        <mat-dialog-content class="modal-content !pt-0">
            <div class="mt-2">

                <div class="p-4 border border-gray-200 rounded bg-white"
                    *ngIf="currentObservation && currentObservation.trim().length > 0">

                    <p class="whitespace-pre-wrap text-sm text-black m-0">
                        <strong>Comentario: </strong>
                        {{ currentObservation }}
                    </p>
                </div>

                <div class="flex justify-center items-center h-32"
                    *ngIf="!currentObservation || currentObservation.trim().length === 0">
                    <p class="text-gray-500 m-0">No hay comentarios disponible</p>
                </div>

            </div>
        </mat-dialog-content>
    </ng-template>

    <ng-template #galleryModal>
        <div class="flex items-center justify-between">
            <h2 mat-dialog-title class="text-lg font-bold">
                Galería de Imágenes ({{ currentImages.length }})
            </h2>
            <div class="flex items-center mr-4">
                <mat-icon svgIcon="heroicons_outline:x-circle" matTooltip="Cerrar" class="cursor-pointer"
                    mat-dialog-close></mat-icon>
            </div>
        </div>

        <mat-dialog-content class="modal-content !pt-0">
            <div class="p-4" *ngIf="currentImages.length > 0">

                <div class="w-full mb-4 border rounded-lg overflow-hidden shadow-lg">
                    <img [src]="currentImageLink" [alt]="currentImages[currentImageIndex].image.alt"
                        class="w-full max-h-[50vh] object-contain mx-auto block">
                </div>

                <div class="flex overflow-x-auto space-x-2 pb-2">
                    <div *ngFor="let img of currentImages; let i = index" class="flex-shrink-0">
                        <img [src]="img.image.link" [alt]="img.image.alt" (click)="setMainImage(i)"
                            class="w-20 h-20 object-cover rounded cursor-pointer border-2 transition-all duration-150"
                            [ngClass]="{'border-indigo-600 ring-2 ring-indigo-300': i === currentImageIndex, 'border-gray-300 hover:border-indigo-400': i !== currentImageIndex}">
                    </div>
                </div>

            </div>

            <div *ngIf="currentImages.length === 0" class="flex justify-center items-center h-32">
                <p class="text-gray-500 m-0">No hay imágenes adjuntas</p>
            </div>
        </mat-dialog-content>
    </ng-template>